<template>
		<div>
				<slot></slot>
				<md-snackbar
								:md-position="snackBar.position"
								:md-duration="snackBar.isInfinity ? Infinity : snackBar.duration"
								:md-active.sync="snackBar.showSnackbar"
								@md-closed="onSnackbarClose()"
								md-persistent
				>
						<span>{{snackBar.snackText}}</span>
						<md-button style="width: 110px;" class="md-primary" @click="hideSnackbar()">Скрыть</md-button>
				</md-snackbar>
		</div>
</template>

<script>
	import {mapGetters} from "vuex";

	export default {
		name: "MainParent",
		data: () => ({
			connectionError: false
		}),
		computed: {
			snackBar() {
				return this.$store.state.snackBar
			},
			...mapGetters(['CURRENTUSER', 'CURRENTAPTEKA', 'ISSITENEEDRELOAD'])
		},
		methods: {
			hideSnackbar() {
				this.$store.dispatch('hideSnackbar')
			},
			ticketsNeedUpdate(data) {
				console.log('ticketsNeedUpdate:', data);
				this.$root.$emit("TicketsNeedUpdateFromMainParent", data);
			},
			siteVersionNeedUpdate(data) {
				console.log('siteVersionNeedUpdate:', data);
				this.$root.$emit("SiteVersionNeedUpdateFromMainParent", data);
			},
			async LoginUsersNeedUpdate(data) {
				console.log('SignalR: LoginUsersNeedUpdate', data);
				await this.$store.dispatch('GET_LOGINUSERS');
			},
			historyMessagesNeedUpdate(data) {
				//если agentNpp === '' значит это агент просмотрел/перешел в заявку и на клиентском сайте нас это не интересует
				if (data.clientNpp === '') return;

				//отправляем событие только тому клиенту который выполнил просмотр/переход в заявку
				if (+this.CURRENTAPTEKA.npp === +data.clientNpp && +this.CURRENTUSER.userId === +data.userId) {
					console.log('HistoryMessagesNeedUpdate:', data);
					this.$root.$emit("HistoryMessagesNeedUpdateFromMainParent", data);
				}
			},
			showHubConnectionState(data) {
				//data.state = 0 - ошибка подключения
				//data.state = 1 - подключение установлено
				if (data.state === 0) {
					this.$store.dispatch("showSnackBar", {
						snackText: 'Отсутствует подключение к серверу. Данные не будут обновляться. Попробуйте перезагрузить страницу.',
						isInfinity: true
					});
					this.connectionError = true;
					console.log('isDisconnectedFromHub = ', this.connectionError);
				} else {
					if (this.connectionError) {
						this.$store.dispatch("showSnackBar", {
							snackText: 'Подключение к серверу установлено.'
						});
					}
					this.connectionError = false;
					console.log('isDisconnectedFromHub = ', this.connectionError);
				}
			},
			onSnackbarClose() {
				if (this.ISSITENEEDRELOAD) {
					return this.$root.$emit("SiteVersionNeedUpdateFromMainParent", {timeStamp: new Date().toLocaleString()});
				}
			}
		},
		created() {
			// Listen events from SignalR
			this.$QBHub.$on('TicketsNeedUpdate', this.ticketsNeedUpdate);
			this.$QBHub.$on('SiteVersionNeedUpdate', this.siteVersionNeedUpdate);
			this.$QBHub.$on('LoginUsersNeedUpdate', this.LoginUsersNeedUpdate);
			this.$QBHub.$on('HistoryMessagesNeedUpdate', this.historyMessagesNeedUpdate);
			this.$QBHub.$on('showHubConnectionState', this.showHubConnectionState);
		},
		beforeDestroy() {
			this.$QBHub.$off('TicketsNeedUpdate', this.ticketsNeedUpdate);
			this.$QBHub.$off('SiteVersionNeedUpdate', this.siteVersionNeedUpdate);
			this.$QBHub.$off('LoginUsersNeedUpdate', this.LoginUsersNeedUpdate);
			this.$QBHub.$off('HistoryMessagesNeedUpdate', this.historyMessagesNeedUpdate);
			this.$QBHub.$off('showHubConnectionState', this.showHubConnectionState);
		}
	}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Components/MainParent.vue